import { render, staticRenderFns } from "./search-statistical.vue?vue&type=template&id=35d6e978"
import script from "./search-statistical.vue?vue&type=script&lang=js"
export * from "./search-statistical.vue?vue&type=script&lang=js"
import style0 from "./search-statistical.vue?vue&type=style&index=0&id=35d6e978&prod&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports